"use client";

import { useLayoutEffect, useState } from "react";

/**
 * Whether the viewport matches `query`: `undefined` until measured, so the
 * server and the first client render agree and nothing reads a guessed
 * answer as a measured one, then kept current across resizes. It is measured
 * in a layout effect, before the first client paint, so what depends on it
 * (which columns the side nav opens with) settles before anyone sees it.
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(undefined);

  useLayoutEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);

  return matches;
}
